import { render } from "./Address.vue?vue&type=template&id=d9b134d2&scoped=true&bindings={\"address\":\"props\"}"
import script from "./Address.vue?vue&type=script&lang=js"
export * from "./Address.vue?vue&type=script&lang=js"

import "./Address.vue?vue&type=style&index=0&id=d9b134d2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d9b134d2"

export default script